import {formatPath} from './utils';
import {CustomerRouteNames} from './route-names';

import NoCustomerAppPage from "../views/NoCustomerAppPage.vue";
import { RouteRecordRaw } from 'vue-router';

export const customerRouter: RouteRecordRaw[] = [
  {
    path: formatPath(CustomerRouteNames.Customer),
    name: CustomerRouteNames.Customer,
    component: NoCustomerAppPage,
  },
];
